import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import ToastModal from "views/components/ToastModal";

const AadharOAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const {aadharTranaction} = useSelector((state) => state.loanApplication);
  const {transactionId, loanApplicationId, loanApplicationNumber} = aadharTranaction;

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getAadharDetails();
  }, []);

  const getAadharDetails = async () => {
    const result = await apiHandler({
      url: endpoint.AADHAR_DETAILS,
      authToken: authToken,
      method:"POST",
      data:{
        transactionId: transactionId
      }
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      // store Login Credentials
      dispatch(saveAadharDetails(result.data));
      navigate("/loanservice/inProcess", {state: {from: 'aadhar-oauth', loanApplicationId, loanApplicationNumber}});
    }
  };
  return (
    <>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </>
  );
};

export default AadharOAuth2RedirectHandler;
